import type { TaskStatus } from "@myapp/contract";

/**
 * A task's Abgabefrist has passed while the task itself is still open — a business rule, not page
 * display logic, so it lives on the entity. `COMPLETED`/`CANCELLED` are terminal: nothing is
 * "überfällig" once there is nothing left to do.
 */
export const isDeadlineOverdue = (
  deadline: string | null | undefined,
  status: TaskStatus,
): boolean => {
  if (!deadline) return false;
  if (status === "COMPLETED" || status === "CANCELLED") return false;
  return new Date(deadline).getTime() < Date.now();
};
